module.exports = __webpack_public_path__ + "img/timeline.630a93ce.svg";